import { type ApexOptions } from 'apexcharts'
import dayjs from 'dayjs'

import { numberUtils } from 'utils'

const defaultTooltip = function ({ series, seriesIndex, dataPointIndex, w }) {
  return `<div class="tooltip-relevance-index">
      <span>
        Moving avg of published videos in ${dayjs(w.globals.categoryLabels[dataPointIndex]).format('MMM D')}: 
        ${numberUtils.shortenWithoutZero(series[seriesIndex][dataPointIndex])}
      </span>
    </div>`
}

interface GetChartOptionsProps {
  tooltip?: (props: any) => any
  colors?: string[]
}

export function getChartOptions({
  tooltip = defaultTooltip,
  colors = ['var(--color_primary_500)'],
}: GetChartOptionsProps) {
  const chartOption: ApexOptions = {
    colors,
    grid: {
      padding: {
        left: 5,
        right: 5,
        top: 5,
        bottom: 5,
      },
    },
    chart: {
      animations: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    yaxis: {
      forceNiceScale: true,
      floating: true,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
        offsetY: 27,
      },
      marker: {
        show: false,
      },
      custom: tooltip,
    },
    markers: {
      size: 0,
    },
    stroke: {
      width: 2,
    },
  }

  return chartOption
}
